module.exports = __webpack_public_path__ + "img/crown.f20ac8c0.svg";